import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';

import { showFlag, dismissFlag } from '../../services';
import type { State } from '../../services/store';
import type { Action, FlagsMapper, Store } from '../../services/types';

import { Dispatcher as DispatcherNew } from './main-new';
import { Dispatcher as DispatcherOld } from './main-old';

export type FlagsDispatcherProps<TAction extends Action, TState> = {
	storeKey?: string;
	store?: Store<TState>;
	mapper: FlagsMapper<TAction, TState>;
};

export const Dispatcher = componentWithFF(
	'jff.magma.react-redux-upgrade_53sr4',
	DispatcherNew,
	DispatcherOld,
);

export const FlagsDispatcher = <TAction extends Action, TState extends State>({
	storeKey,
	store,
	mapper,
}: FlagsDispatcherProps<TAction, TState>) =>
	ff('jff.magma.react-redux-upgrade_53sr4') ? (
		<DispatcherNew store={store} mapper={mapper} showFlag={showFlag} dismissFlag={dismissFlag} />
	) : (
		<DispatcherOld
			storeKey={storeKey}
			mapper={mapper}
			showFlag={showFlag}
			dismissFlag={dismissFlag}
		/>
	);
